import { Globe, Phone, MessageSquare } from "lucide-react";
import { Badge } from "./ui/badge";

// Conversation modality of a run/call, derived from run.voice_call_mode:
//   "text" → Text, "web_call" → Web, anything else (e.g. "phone") → Phone.
const TYPES = {
  web_call: {
    label: "Web",
    Icon: Globe,
    cls: "bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 border-transparent",
  },
  phone: {
    label: "Phone",
    Icon: Phone,
    cls: "bg-teal-50 text-teal-700 dark:bg-teal-950/40 dark:text-teal-300 border-transparent",
  },
  text: {
    label: "Text",
    Icon: MessageSquare,
    cls: "bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300 border-transparent",
  },
};

export default function ConversationTypeBadge({ mode, className = "" }) {
  const t = TYPES[mode] || TYPES.phone;
  const { Icon } = t;
  return (
    <Badge className={`${t.cls} ${className}`}>
      <Icon />
      {t.label}
    </Badge>
  );
}
